<ng-container *ngFor="let serieSummary of seriesSummary; let last = last; let first = first">
  <div
    *ngIf="first && serieSummary.period"
    class="flex flex-row flex-wrap justify-start items-center"
  >
    <p class="header">{{ 'CHART.PERIOD_SUMMARY_HEADER' | translate }}&nbsp;</p>
    <p class="header no-wrap">
      {{ serieSummary.period.start | date }}&nbsp;-&nbsp;{{ serieSummary.period.end | date }}
    </p>
  </div>
  <div class="period-row-padding flex flex-row justify-between items-start">
    <div class="flex flex-row justify-start items-center">
      <div class="bullet" [ngClass]="serieSummary.color"></div>
      <p>{{ serieSummary.designationKey | translate }}</p>
    </div>
    <div class="flex flex-col justify-around items-end">
      <ng-container *ngIf="serieSummary.sumValueOfThePeriod">
        <p
          *ngIf="
            energyService.getTransformedEnergyDetailsFromValueAndUnit(
              serieSummary.sumValueOfThePeriod,
              serieSummary.unit
            ) | featureLike: 'value':'unit' as featureLike
          "
          class="thick"
        >
          {{ featureLike | value2: featurePropertyKey.value }}
          {{ featureLike | unit: featurePropertyKey.value }}
        </p>
      </ng-container>
      <p *ngIf="serieSummary.color && serieSummary.averageValueOfThePeriod">
        <span *ngIf="serieSummary.unit !== 'percent'">(</span>
        <ng-container
          *ngIf="
            energyService.getTransformedEnergyDetailsFromValueAndUnit(
              serieSummary.averageValueOfThePeriod,
              serieSummary.unit
            ) | featureLike: 'value':'unit' as featureLike
          "
        >
          {{ featureLike | value2: featurePropertyKey.value }}
          {{ featureLike | unit: featurePropertyKey.value }}/{{ periodSingularName | translate }}
        </ng-container>
        <span *ngIf="serieSummary.unit !== 'percent'">)</span>
      </p>
    </div>
  </div>
  <hr *ngIf="!last" />
</ng-container>
